import TYPES from './types';
import { get, put } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const getVisibility = params => dispatch => {
  const { type, id, ...rest } = params;

  dispatch({ type: TYPES.GET_VISIBILTY.START, payload: { params } });

  return get(`/${type}/${id}/visibility`, rest)
    .then(response => {
      dispatch({ type: TYPES.GET_VISIBILTY.SUCCESS, payload: response.data });

      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.GET_VISIBILTY.ERROR, payload: error }));
};

export const updateVisibility = params => dispatch => {
  const { id, type, table, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_VISIBILTY.START, payload: { params } });

  return put(`/${type}/${id}/visibility`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_VISIBILTY.SUCCESS, payload: response.data });
      if (table) {
        dispatch(updateTableRow({ data: response.data, table }));
      }
      dispatch(successHandler({ title: 'Success!', message: 'Updated visibility' }));

      return response.data;
    })
    .catch(error => {
      if (table) {
        dispatch(resetTableRowUpdate({ data: params, table }));
      }

      dispatch({ type: TYPES.GET_VISIBILTY.ERROR, payload: error });
    });
};
